import React from 'react';
import PropTypes from 'prop-types';

import TruncatedMultiLineText from 'dpl/components/TruncatedMultiLineText';
import { isMobileUA } from 'dpl/shared/utils';
import Icon from 'dpl/common/components/Icon';

const TRUNCATED_LENGTH = isMobileUA() ? 60 : 80;

export default function FaqItem({ title, description, isOpen, onClick }) {
  return (
    /* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/interactive-supports-focus */
    <div
      role="button"
      className="BreederJoinFaqItem pointer pv4 pv6-sm"
      onClick={onClick}
    >
      <div className="flex items-center align-items-start justify-between pv1">
        <div className="pr10">
          <p className="f4-lg fw-medium">{title}</p>
          <div className="f4-lg">
            <TruncatedMultiLineText
              isOpen={isOpen}
              text={description}
              length={TRUNCATED_LENGTH}
              setInnerHTML
            />
          </div>
        </div>
        <Icon name="plus" className="ml2 stone-700" />
      </div>
    </div>
  );
}

FaqItem.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};
